<template>
    <div id="body">
        <div id="content">
            <div id="content-inner">
                <div class="login-container">
                    <rkm-col class="login-aside">
                        <div class="wallpaper">
                            <div class="aside-content">
                                <div class="aside-title">ConectaSUS ⋅ Sistema de Gestão de Saúde Pública</div>
                                <div class="aside-city">{{customer ? customer.nome : null}}</div>
                                <div class="aside-actions">
                                    <rkm-button><rkm-icon icon="headset" /> Dificuldade pra entrar? Pedir ajuda</rkm-button>
                                </div>
                            </div>
                        </div>
                    </rkm-col>
                    <rkm-col class="login-right">
                        <div class="login-header">
                            <img
                                :src="customer && customer.logotipo ? require(`@/assets/cliente/logotipo/${customer.logotipo}`) : null"
                                width="140"
                            />
                        </div>

                        <slot />

                        <div class="login-footer">
                            <div
                                v-if="customer && (!customer.ativo || customer.motivoInativacao)"
                                class="motivo-inativacao"
                            >
                                {{customer.motivoInativacao}}
                            </div>
                        </div>
                    </rkm-col>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({customer: 'getCustomer'}),
    },
}
</script>

<style scoped>
.login-container {
    display: flex;
    align-items: center;
    height: 100vh;
    justify-content: space-evenly;
    box-shadow: -10px 0px 70px -80px rgb(0 0 0 / 50%) inset;
    background: var(--primary) url('~@/assets/images/login/medical-2.jpg');
    background-blend-mode: multiply;
    background-size: cover;
    background-position: center center;
}

.login-container:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    z-index: 0;
}

.login-aside {
    flex: 0 1 auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
    width: 450px;
}

.aside-actions .btn {
    background: rgb(255 255 255 / 21%);
    border: none;
    border-radius: 0.25rem;
    padding: 0.5rem;
    position: relative;
    height: auto;
    color: #FFF;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 0.8rem;
}

.aside-title {
    font-weight: 600;
    font-size: 1.2rem;
}

.aside-city {
    font-weight: 100;
    font-size: 4.5rem;
    line-height: 1;
}

.aside-content {
    text-align: center;
}

.aside-actions {
    display: none;
}

.wallpaper {
    color: #FFF;
    font-size: 2rem;
    line-height: 1.2;
    text-shadow: 0.5px 0.5px #282a2c;
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-right {
    align-self: start;
    justify-content: space-between;
    align-items: center;
    display: flex;
    background: #FFF;
    flex-direction: column;
    flex: 0 1 auto;
    padding: 0;
    margin: 3rem 0;
    width: auto;
    border-radius: 2rem;
    height: calc(100% - 6rem);
    width: 35vw;
}

#body >>> .login-right > * {
    width: 100%;
}

.login-header {
    width: 100%;
    padding: 60px 10px 10px 10px;
    text-align: center;
}

.login-footer {
    background: rgba(255, 255, 255, 0.04);
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    padding: 10px 5px;
    text-align: center;
    width: 100%;
}

.motivo-inativacao {
    color: red;
    font-size: 20px;
    font-weight: bold;
}

.btn svg {
    margin-right: 5px;
}

#body >>> .login-form h1 {
    font-size: 1.8rem;
    line-height: 1;
    margin-bottom: 2rem;
    font-weight: 400;
    color: #6c757d;
}

#body >>> .login-form h1 span {
    color: var(--primary);
    font-weight: 200;
    text-transform: initial;
    letter-spacing: 0px;
}

#body >>> .login-form-actions .btn[type="submit"] {
    width: 100%;
    height: auto;
}

#body >>> .login-form-actions .btn[type="submit"] {
    width: 100%;
    height: auto;
    border-radius: 100px;
    padding: 0.7rem;
}

#body >>> .login-form-actions .btn[type="submit"] + .btn {
    background: none;
    color: var(--gray);
    margin: 0.5rem 0 0 0;
    border: none;
    text-align: center;
    display: block;
    box-shadow: none;
}

#body >>>  .login-form {
    padding: 0 60px;
}

#body >>> h5 {
    font-size: 17px;
}

#body >>> h6 {
    font-size: 12px;
    opacity: 0.5;
    margin: 6px 0 0 0;
}

</style>